import { useLocationCheckpoint } from "../hooks/useLocationCheckpoint.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx } from "react/jsx-runtime";
//#region src/modules/Locations/shared/CheckpointName.tsx
var CheckpointName = ({ checkpointId }) => {
	const { data, loading } = useLocationCheckpoint({ checkpointId }, { cacheStrategy: "cache-only" });
	if (!data?.checkpoint && loading) return /* @__PURE__ */ jsx(Skeleton.Text, { chars: 25 });
	if (!data?.checkpoint) return null;
	return /* @__PURE__ */ jsx(Fragment$1, { children: data.checkpoint.name });
};
//#endregion
export { CheckpointName };

//# sourceMappingURL=CheckpointName.js.map